/* ASG Policy Page — Orphaned <style> Cleanup
   --------------------------------------------
   The Shopify policies editor strips <style> tags but leaves the CSS
   rules behind as plain text nodes inside the .rte container. This
   script finds and removes those orphaned text nodes so they don't
   render as visible page text.

   We look for direct child text nodes of .shopify-policy__body .rte
   that match the shape of CSS (contain "{" followed by ":" and ";"
   or "}") and remove them.
*/

(function () {
  function looksLikeCss(text) {
    if (!text || text.length < 10) return false;
    // Must contain { and } and at least one CSS-style declaration (prop: value;)
    var hasBraces = text.indexOf('{') !== -1 && text.indexOf('}') !== -1;
    var hasDecl = /[a-z-]+\s*:\s*[^;}]+[;}]/i.test(text);
    return hasBraces && hasDecl;
  }

  function cleanPolicyBody() {
    var rte = document.querySelector('.shopify-policy__body .rte');
    if (!rte) return;

    // Walk direct and nested text nodes; remove ones that look like CSS rules.
    var walker = document.createTreeWalker(rte, NodeFilter.SHOW_TEXT, null);
    var toRemove = [];
    var node;
    while ((node = walker.nextNode())) {
      // Skip text inside legitimate inline elements (strong, em, a, p, h2, h3, li)
      // by checking the parent isn't one of the styled containers
      var parent = node.parentNode;
      if (!parent) continue;

      var tag = (parent.tagName || '').toLowerCase();
      // Only consider text nodes whose parent is the .rte div itself or a generic div
      // (i.e. NOT inside our card content elements)
      if (tag !== 'div' && tag !== 'rte') {
        // It's inside p/h2/h3/li/strong/em/a/ul — legitimate content, leave alone
        continue;
      }

      // Also require the parent be .rte or .asg-policy itself — not inside a card
      if (!parent.classList.contains('rte') && !parent.classList.contains('asg-policy')) {
        continue;
      }

      if (looksLikeCss(node.nodeValue)) {
        toRemove.push(node);
      }
    }

    toRemove.forEach(function (n) {
      n.parentNode.removeChild(n);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanPolicyBody);
  } else {
    cleanPolicyBody();
  }
})();
